import { useContext, useMemo } from "react";
import { ManagerContext } from "../context/ManagerContext";
import { api, baseURL } from "../services/api";

const updateFavicon = (iconPath) => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
        link.href = iconPath;
    } else {
        const newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = iconPath;
        document.head.appendChild(newLink);
    }
};

const ManagerUpdater = () => {
    const { manager, setManager } = useContext(ManagerContext);

    useMemo(() => {
        async function getManager() {
            const path = window.location.pathname;
            try {
                const { data } = await api.get('/configs/1?populate=logo');
                const logo = data.data?.attributes?.logo?.data?.attributes?.url  || '';
                data.data.attributes.logo_url = logo ? baseURL + logo : '';    
                console.log('path', path)
                if (path.startsWith('/apeprev')) {
                    data.data.attributes.config_path = 'apeprev';
                    setManager(data.data.attributes);
                    updateFavicon("/favicons/apeprev.ico");
                } else if (path.startsWith('/semper')) {
                        data.data.attributes.config_path = 'semper';
                        setManager(data.data.attributes);
                        updateFavicon("/favicons/semper.ico");
                } else {
                    data.data.attributes.config_path = 'agip';
                    setManager(data.data.attributes);
                    updateFavicon("/favicons/agip.ico");

                }
            } catch (error) {
                console.log(error);
            }
        }
        if (manager.config_path) return;
        getManager();

    }, [window.location.pathname]);

    return null;
};

export default ManagerUpdater;